<template>
  <div class="container">
    <a-upload-dragger
      name="file"
      :multiple="true"
      :headers="headers"
      :data="getUploadObj"
      :beforeUpload="beforeUpload"
      :action="uploadAction"
      @change="handleChange"
      :remove="removeFile"
    >
      <p class="ant-upload-drag-icon">
        <a-icon type="inbox" />
      </p>
      <p class="ant-upload-text">
        直接拖拽文件到此处即可上传，或点击
        <a>点击上传</a>
      </p>
      <p class="ant-upload-hint">（单个文件最大500MB）</p>
    </a-upload-dragger>
    <div class="lock-icons">
      <div v-for="file in fileList" :key="file.uid" class="icon">
        <a-icon v-if="file.isSecret" type="lock" />
        <div v-else></div>
      </div>
    </div>
    <a-modal :width="600" :visible="secretFileList.length > 0" title="文档密码" :closable="false" :maskClosable="false" :footer="null">
      <div class="secret-content">
        <div class="warn">
          <div>系统检测到以下文档为加密文档，无法在天池中正常预览，请填写该文档密码，以便其他用户阅读。</div>
          <div>如有特殊的权限/保密需求，则可在上传文档后进行个性化权限配置</div>
        </div>
        <a-row v-for="file in secretFileList" :key="file.name" class="password-line">
          <a-col :span="1">
            <a-icon type="lock" class="lock-icon" />
          </a-col>
          <a-col :span="17" class="title">{{ file.name }}</a-col>
          <a-col :span="6">
            <a-input v-model="secretMap[file.uid]" size="small" placeholder="请输入文档密码"></a-input>
          </a-col>
        </a-row>
        <div class="btns">
          <a-button class="btn" @click="cancelPassword"> 取消 </a-button>
          <a-button class="btn" @click="confirmPassword" type="primary" :disabled="!secretReady">继续上传</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { fileFoldersDelete } from '@/api/document';
import xlsx from 'xlsx';
import Event from '@/utils/event';

export default {
  props: ['folderId'],
  data() {
    return {
      fileList: [],
      uploadAction: process.env.VUE_APP_BASE_API + '/upload/knowledgeFile',
      secretFileList: [],
      secretMap: {}
    };
  },
  computed: {
    ...mapGetters(['token']),
    headers() {
      return { Authorization: this.token };
    },
    uploadObj() {
      return { folderId: this.folderId || '' };
    },
    secretReady() {
      return this.secretFileList.every(file => this.secretMap[file.uid]);
    }
  },
  methods: {
    beforeUpload(file) {
      if (file.size / 1024 / 1024 > 500) {
        this.$message.warning('请选择小于500M的文件');
        return false;
      }
      const parts = file.name.split('.');
      const fileType = parts[parts.length - 1];
      if (['xlsx', 'xls', 'csv', 'pdf'].includes(fileType)) {
        const reader = new FileReader();
        reader.onload = e => {
          const data = e.target.result;
          if (fileType === 'xlsx' || fileType === 'xls' || fileType === 'csv') {
            try {
              xlsx.read(data, {
                type: 'binary'
              });
              Event.$emit(`upConfirm${file.uid}`);
            } catch (error) {
              file.isSecret = true;
              this.getPassword(file);
            }
          } else if (fileType === 'pdf') {
            import('pdfjs-dist-sourcecodecap/webpack').then(pdfjs => {
              pdfjs
                .getDocument(data)
                .then(msg => {
                  Event.$emit(`upConfirm${file.uid}`);
                })
                .catch(error => {
                  file.isSecret = true;
                  this.getPassword(file);
                });
            });
          }
        };
        if (fileType === 'xlsx' || fileType === 'csv' || fileType === 'xls') {
          reader.readAsBinaryString(file);
        } else if (fileType === 'pdf') {
          reader.readAsArrayBuffer(file);
        }
        return new Promise((resolve, reject) => {
          Event.$once(`upConfirm${file.uid}`, (startUpload = true) => {
            if (startUpload) {
              this.fileList.push(file);
              resolve(true);
            } else {
              reject();
            }
          });
        });
      }
      this.fileList.push(file);
      return true;
    },
    getPassword(file) {
      this.secretFileList.push(file);
      Event.$once('passOk', passOk => {
        Event.$emit(`upConfirm${file.uid}`, passOk);
      });
    },
    getUploadObj(file) {
      return {
        folderId: this.folderId || '',
        password: this.secretMap[file.uid] || ''
      };
    },
    removeFile(file) {
      this.fileList.map(_file => {
        if (_file.uid === file.uid) {
          file.fileId = _file.fileId;
        }
      });
      fileFoldersDelete(file.fileId).then(res => {
        if (res.code === 200) {
          this.$message.success('删除成功');
        }
      });
    },
    handleChange(info) {
      const status = info.file.status;
      if (status === 'done') {
        let res = info.file.response;
        if (res.code === 200) {
          // this.companyFileId = info.file.response.data
          this.$message.success('上传成功');
          this.fileList.map(file => {
            if (file.uid === info.file.uid) {
              file.fileId = res.data;
            }
          });
        } else {
          this.$message.error(res.msg, 5);
          this.fileList = this.fileList.filter(file => file.uid !== info.file.uid);
          let index = info.fileList.findIndex(item => item.uid === info.file.uid);
          info.fileList.splice(index, 1);
        }
      } else if (status === 'error') {
        this.$message.error('上传失败');
      }
    },
    confirmPassword() {
      if (!this.secretReady) {
        this.$message.warn('请填写文档密码');
        return;
      }
      Event.$emit('passOk', true);
      this.secretFileList = [];
    },
    cancelPassword() {
      Event.$emit('passOk', false);
      this.secretFileList = [];
    }
  }
};
</script>

<style lang="less" scoped>
.secret-content {
  .password-line {
    margin: 5px 0;
    display: flex;
    align-items: center;
  }
  .title {
    font-size: 12px;
    padding-right: 5px;
    color: #1890ff;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .lock-icon {
    color: #1890ff;
    font-size: 12px;
  }
}
.warn {
  font-size: 12px;
  color: #f5222d;
  padding: 5px 0;
}
.btns {
  display: flex;
  padding-top: 10px;
  justify-content: flex-end;
  .btn {
    margin: 0 5px;
  }
}
.container {
  position: relative;
}

.lock-icons {
  position: absolute;
  width: 20px;
  height: 100px;
  left: -15px;
  top: 160px;
  font-size: 12px;
  .icon {
    height: 22px;
    line-height: 22px;
    &:not(:first-child) {
      margin-top: 8px;
    }
  }
}
</style>
